import {Center} from '@mantine/core'
import {useEffect, useMemo, useState} from 'react'
import {changeTextCapital} from '../../../_metronic/helpers/AssetHelpers'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import InputErrorBox from '../../components/InputErrorBox'
import {getUserAsset, handleInputChange} from './AssignAssetsFunction'
import {ToastContainer} from 'react-toastify'

const Assets = ({userAsset, setUserAsset, fetchAssets, isModalOpen}) => {
  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  //Search 2
  const [searchTerm, setSearchTerm] = useState('');
  // Pagination
  const [currentPage, setCurrentPage] = useState(1)
  const recordsPerPage = 10
  

  //Description Inside Reaad More button
  const [expandedDescriptionRows, setExpandedDescriptionRows] = useState<string[]>([]);
  
  const cancleEdit = useMemo(() => {
    if (isModalOpen) {
      setEditId(null)
    }
  }, [isModalOpen])
  const initialState = {
    category: '',
    user: '',
    brand: '',
    serialNo: '',
    issueDate: '',
    returnDate: '',
    description: '',
  }
  const [inputField, setInputField] = useState(initialState)

  const fetchUserAssets = () => {
    getUserAsset(setUserAsset, setAPIStatus)
  }
  useEffect(() => {
    let mounted = true
    if (mounted) {
      fetchUserAssets()
      fetchAssets()
    }
    return () => {
      mounted = false
    }
  }, [])

  //Search 2
  const filteredUserAssets = userAsset?.filter((obj: any) => {
  const employeeCode = obj?.user?.employeeCode ?? '';
  const fullName = `${obj?.user?.firstName ?? ''} ${obj?.user?.lastName ?? ''}`;
  const assetTag = `${obj?.asset?.category ?? ''} - ${obj?.asset?.brand ?? ''}`;
  const serialNo = obj?.asset?.serialNo ?? '';

    const combinedString = `
      ${employeeCode}
      ${fullName}
      ${assetTag}
      ${serialNo}
    `.toLowerCase();

    return combinedString.includes(searchTerm.toLowerCase());
  });

  // Pagination Logic
  const totalRecords = filteredUserAssets?.length ?? 0
  const totalPages = Math.ceil(totalRecords / recordsPerPage)

  const startIndex = (currentPage - 1) * recordsPerPage
  const endIndex = startIndex + recordsPerPage

  const currentRecords = filteredUserAssets?.slice(startIndex, endIndex) ?? []

  // Reset pagination when search changes
  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm])

  // Keep page valid when records change
  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages)
    } else if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1)
    }
  }, [totalPages, currentPage])

  //Description Inside Read More button
  const toggleDescription = (id: string) => {
    setExpandedDescriptionRows((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };
  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
              <div className='card-title'>Assignee Details</div>
            </div>
            {/* begin:: card body */}
            <div className='card-body'>
              {/*  SEARCH BAR- 2 */}
              <div className='mb-4' style={{ maxWidth: '350px' }}>
                <div className='input-group'>
                  <span className='input-group-text bg-white'>
                    <i className='fa fa-search text-muted'></i>
                  </span>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Search by Employee Code, Name, Asset Tag or Serial No...'
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              {APIStatus.submitLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : APIStatus.error != null ? (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
                </div>
              ) : (
                <div className='table-responsive  '>
                  <table
                    className='table 
                    table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold'>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '130px'}}>
                          {changeTextCapital('Employee Code - Name')}
                        </th>

                        <th className='pl-1 text-center text-muted' style={{minWidth: '90px'}}>
                          {changeTextCapital('Asset Tag')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('Asset Serial No')}
                        </th>
                        <th
                          className='pl-1 text-center text-muted'
                          style={{width: '150px', whiteSpace: 'pre-wrap'}}
                        >
                          {changeTextCapital('Description')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '50px'}}>
                          {changeTextCapital('Location')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Issue Date')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Return Date')}
                        </th>
                        

                        {/* <th className='pl-1 text-center text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Action')}
                        </th> */}
                      </tr>
                    </thead>
                    {/* {userAsset?.length > 0 ? (  */}
                    {filteredUserAssets?.length > 0 ? (
                      <tbody>
                        {userAsset &&
                          // userAsset.map((obj: any, index: number) => (
                          currentRecords.map((obj: any, index: number) => (
                            <tr
                              className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                              key={obj?.id ?? '-'}
                            >
                              <td className='text-center'>{startIndex + index + 1}</td>
                              <td className='text-center'>
                                {obj?.user?.firstName ?? '-'} {obj?.user?.lastName ?? '-'}
                              </td>

                              <td className='text-center'>
                                {obj?.asset?.category && obj?.asset?.brand 
                                  ? `${obj.asset.category} - ${obj.asset.brand}` 
                                  : obj?.asset?.category || obj?.asset?.brand || '-'}
                              </td>
                              <td
                                className='text-center'
                                style={{
                                  maxWidth: '200px',
                                  
                                  whiteSpace: 'pre-wrap',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {obj?.asset?.serialNo ?? '-'}
                              </td>
                              {/* <td
                                className='text-center'
                                style={{
                                  maxWidth: '400px',
                                  whiteSpace: 'pre-wrap',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {obj?.asset?.description ?? '-'}
                              </td> */}
                              {/* Description Inside Reaad More button */}
                              <td
                                style={{
                                        fontSize: '12px',
                                        whiteSpace: 'pre-line',
                                        cursor: 'pointer',
                                        marginLeft: '5px',
                                      }}
                              >
                                {obj?.asset?.description ? (
                                  <>
                                    {expandedDescriptionRows.includes(obj.id)
                                      ? obj.asset.description
                                      : obj.asset.description.split(' ').slice(0, 7).join(' ') +
                                        (obj.asset.description.split(' ').length > 7 ? '...   ' : '')}

                                    {obj.asset.description.split(' ').length > 7 && (
                                      <span
                                        // className="ms-2"
                                        style={{
                                          color: '#0d6efd',      // Blue text
                                          fontSize: '12px',      // Smaller font
                                          cursor: 'pointer',     // Hand cursor
                                          marginLeft: '5px',     // Space before Read More
                                          fontWeight: 500
                                        }}
                                        onClick={() => toggleDescription(obj.id)}
                                      >
                                        {expandedDescriptionRows.includes(obj.id)
                                          ? 'Read Less'
                                          : 'Read More'}
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  '-'
                                )}
                              </td>
                              <td className='text-center'>
                                {obj?.locationType && obj?.location
                                  ? `${obj.locationType.charAt(0).toUpperCase() + obj.locationType.slice(1)} - ${obj.location}`
                                  : obj?.location || '-'}
                              </td>
                              <td className='text-center'>
                                {obj?.issueDate 
                                  ? new Date(obj.issueDate).toLocaleDateString('en-GB', {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit'
                                    })
                                  : '-'}
                              </td>
                              {/* <td className='text-center'>
                                {obj?.returnDate 
                                  ? new Date(obj.returnDate).toLocaleDateString('en-GB', {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit'
                                    })
                                  : '-'}
                              </td> */}
                             <td className='text-center'>
  {editId === obj?.id ? (
    <input
      className='form-control'
      type='date'
      name='returnDate'
      value={inputField.returnDate}
      onChange={(e) =>
        handleInputChange(e, setInputField, inputField)
      }
    />
  ) : (
    <div>
      {obj?.returnDate
        ? new Date(obj.returnDate).toLocaleDateString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })
        : '-'}
    </div>
  )}
</td>


                              {/* {obj?.returnDate == null ? (
                                <td>
                                  <div className='d-flex justify-content-center flex-shrink-0'>
                                    {editId === obj?.id ? (
                                      <>
                                        <button
                                          className='btn btn-icon btn-success btn-sm me-1'
                                          onClick={() => {
                                            if (!SubmitAPIStatus.loading) {
                                              handleSubmit(
                                                inputField,
                                                setUserAsset,
                                                setEditId,
                                                initialState,
                                                setInputField,
                                                editId,
                                                cancelSubmit,
                                                setAPIStatus,
                                                setInputError,
                                                validateForm,
                                                setSubmitAPIStatus,
                                                fetchAssets
                                              )
                                            }
                                          }}
                                          disabled={SubmitAPIStatus.loading} // Disable the button when loading
                                        >
                                          <i className='far fa-save'></i>
                                        </button>

                                        <button
                                          className='btn btn-icon btn-light-danger btn-sm'
                                          onClick={() => {
                                            cancelSubmit(
                                              setInputField,
                                              initialState,
                                              setEditId,
                                              setInputError
                                            )
                                            setEditId(null)
                                          }}
                                        >
                                          <i className='far fa-window-close'></i>
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        className='btn btn-icon btn-light-primary btn-sm me-1'
                                        onClick={() => {
                                          getUserAssetById(
                                            obj?.id,
                                            inputField,
                                            setInputField,
                                            setEditId,
                                            setInputError
                                          )
                                          setEditId(obj?.id)
                                        }}
                                      >
                                        <i className='far fa-edit'></i>
                                      </button>
                                    )}
                                  </div>
                                </td>
                              ) : (
                                <td>
                                  {' '}
                                  <div className='text-center'>-</div>
                                </td>
                              )} */}
                            </tr>
                          ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={9}>
                            <Center>No Record Available.</Center>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              )}
              {/* Pagination Controls */}
            {totalRecords > 0 && (
              <div className='d-flex flex-wrap justify-content-between align-items-center mt-5 gap-3'>
                <div className='text-muted'>
                  Showing {startIndex + 1} to {Math.min(endIndex, totalRecords)} of{' '}
                  {totalRecords} records
                </div>

                <div className='d-flex align-items-center gap-2'>
                  <button
                    type='button'
                    className='btn btn-sm btn-light-primary'
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                  >
                    Previous
                  </button>

                  {Array.from({ length: totalPages }, (_, index) => index + 1).map(
                    (page) => (
                      <button
                        key={page}
                        type='button'
                        className={`btn btn-sm ${
                          currentPage === page ? 'btn-primary' : 'btn-light-primary'
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    )
                  )}

                  <button
                    type='button'
                    className='btn btn-sm btn-light-primary'
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Assets
